module.exports = __webpack_public_path__ + "img/home-safe-chauffeur.12a15088.png";